import React, { useEffect, useRef } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Header } from "../../components/landing/header";
import { Footer } from "../../components/landing/footer";
import "./Services.css";
import { Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import SecureIcon from "../../assets/images/landing_page/circle-check-icon.png";
import HeroImage from "../../assets/images/services1.jpg";
import ConsumerImage from "../../assets/images/services2.jpg";
import ManufacturerImage from "../../assets/images/services3.jpg";

const Services = () => {
  const navigate = useNavigate();
  const timelineRef = useRef(null);
  const timelineLineRef = useRef(null);

  useEffect(() => {
    const updateTimelineLine = () => {
      if (timelineRef.current && timelineLineRef.current) {
        const firstCircle = timelineRef.current.querySelector('.timeline-number');
        const lastCircle = timelineRef.current.querySelectorAll('.timeline-number')[4];

        if (firstCircle && lastCircle) {
          const firstRect = firstCircle.getBoundingClientRect();
          const lastRect = lastCircle.getBoundingClientRect();
          const timelineRect = timelineRef.current.getBoundingClientRect();

          const topOffset = firstRect.top - timelineRect.top + (firstRect.height / 2);
          const bottomOffset = lastRect.top - timelineRect.top + (lastRect.height / 2);

          timelineLineRef.current.style.top = `${topOffset}px`;
          timelineLineRef.current.style.height = `${bottomOffset - topOffset}px`;
          timelineLineRef.current.style.bottom = 'auto';
        }
      }
    };

    updateTimelineLine();
    window.addEventListener('resize', updateTimelineLine);

    return () => {
      window.removeEventListener('resize', updateTimelineLine);
    };
  }, []);

  return (
    <div>
      <Header />

      {/* Hero Section */}
      <section className="section hero-section">
        <div className="container">
          <div className="row hero-row align-items-center">
            <div className="col-lg-6 hero-text">
              <div className="title-section">
                <h2>
                  You've spent money to get products on shelves.{" "}
                  <span>Now make sure they move.</span>
                </h2>
                <p>
                  Create secure, scannable GS1 digital coupons accepted nationwide. Whether
                  you're launching a new product or bringing back a customer favorite, we make
                  coupons simple, secure, and cost-effective.
                </p>
                <a href="#contact">
                  <button className="theme-btn">Contact Us</button>
                </a>
              </div>
            </div>
            <div className="col-lg-6 hero-img-area">
              <div className="position-relative">
                <Image src={HeroImage} alt="Hero" className="img-fluid main-img" />
                <div className="feature-block position-absolute hero-feature1">
                  <div style={{
                    backgroundColor: '#3b82f6',
                    borderRadius: '50%',
                    width: '48px',
                    height: '48px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3 3V21H21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M7 16L12 11L15 14L21 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <span>Track performance</span>
                </div>
                <div className="feature-block position-absolute hero-feature2">
                  <div style={{
                    backgroundColor: '#22c55e',
                    borderRadius: '50%',
                    width: '48px',
                    height: '48px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <span>Real-Time Validation</span>
                </div>
                <div className="feature-block position-absolute hero-feature3">
                  <div style={{
                    backgroundColor: '#f97316',
                    borderRadius: '50%',
                    width: '48px',
                    height: '48px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10.29 3.86L1.82 18C1.64537 18.3024 1.55296 18.6453 1.55199 18.9945C1.55101 19.3437 1.64149 19.6871 1.81442 19.9905C1.98735 20.2939 2.23672 20.5467 2.53771 20.7239C2.83869 20.9011 3.18082 20.9962 3.53 21H20.47C20.8192 20.9962 21.1613 20.9011 21.4623 20.7239C21.7633 20.5467 22.0127 20.2939 22.1856 19.9905C22.3585 19.6871 22.449 19.3437 22.448 18.9945C22.447 18.6453 22.3546 18.3024 22.18 18L13.71 3.86C13.5318 3.56611 13.2807 3.32312 12.9812 3.15448C12.6817 2.98585 12.3437 2.89725 12 2.89725C11.6563 2.89725 11.3183 2.98585 11.0188 3.15448C10.7193 3.32312 10.4682 3.56611 10.29 3.86Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M12 9V13" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <circle cx="12" cy="17" r="0.5" fill="white" stroke="white" strokeWidth="1.5"/>
                    </svg>
                  </div>
                  <span>Eliminate Fraud</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-shadow shadow1"></div>
      </section>

      {/* The Next Generation of Coupons Section */}
      <section className="section next-gen-section">
        <div className="container">
          <div className="section-title text-center">
            <h2>The Next Generation of Coupons</h2>
            <p className="intro">
              The Next Generation of Coupons. Universal coupons for a digital-first world,<br />
              8112 digital coupons are:
            </p>
          </div>
          <div className="services-container mt-5">
            <div className="row">
              <div className="col-lg-4 col-md-6 mb-4">
                <div className="service-item">
                  <div className="service-icon">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" stroke="#0032a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11" stroke="#0032a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <circle cx="12" cy="16" r="1.5" fill="#0032a1"/>
                      <path d="M12 17.5V19" stroke="#0032a1" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                  </div>
                  <div>
                    <h3>Secure</h3>
                    <p>Real-time validation at checkout that prevents fraud and guarantees every coupon is authenticated.</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mb-4">
                <div className="service-item">
                  <div className="service-icon">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="#0032a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <div>
                    <h3>Savings - Instant redemption</h3>
                    <p>No printouts. No hassle. Just quick and easy savings. Savings are applied easy with clip to register.</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mb-4">
                <div className="service-item">
                  <div className="service-icon">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="#0032a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M14 2V8H20" stroke="#0032a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M8 13H16" stroke="#0032a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M8 17H12" stroke="#0032a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <div>
                    <h3>Measurable</h3>
                    <p>Clear, actionable insights that show how your coupons perform and deliver value before rollout.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Consumers Section */}
      <section className="section consumers-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="title-section">
                <h2>Consumers</h2>
                <p>Your Savings Simplified with Digital Coupons.</p>
              </div>
              <ul className="benefit-list">
                <li>Redeem multiple coupons in one scan.</li>
                <li>No printing required—just right at checkout.</li>
                <li>Always valid and secure with GS1 digital verification.</li>
                <li>Secure digital codes ensure your savings work every time.</li>
              </ul>
              <div className="app-buttons mt-4">
                <h5>Start Saving Today — Download the ClipCoupons App</h5>
                <div className="d-flex gap-3 mt-3">
                  <a href="#" className="app-store-btn">
                    <img src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" alt="App Store" height="40"/>
                  </a>
                  <a href="#" className="google-play-btn">
                    <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Google Play" height="40"/>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="consumer-image position-relative">
                <Image src={ConsumerImage} alt="Consumer App" className="img-fluid" />
                <div className="feature-block position-absolute hero-feature1">
                  <div style={{
                    backgroundColor: '#3b82f6',
                    borderRadius: '50%',
                    width: '48px',
                    height: '48px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="5" y="2" width="14" height="20" rx="2" ry="2" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M12 18H12.01" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <span>Secure digital</span>
                </div>
                <div className="feature-block position-absolute hero-feature2">
                  <div style={{
                    backgroundColor: '#f97316',
                    borderRadius: '50%',
                    width: '48px',
                    height: '48px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 6H4C2.89543 6 2 6.89543 2 8V16C2 17.1046 2.89543 18 4 18H20C21.1046 18 22 17.1046 22 16V8C22 6.89543 21.1046 6 20 6Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M2 10H6C6.53043 10 7.03914 10.2107 7.41421 10.5858C7.78929 10.9609 8 11.4696 8 12C8 12.5304 7.78929 13.0391 7.41421 13.4142C7.03914 13.7893 6.53043 14 6 14H2" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M22 10H18C17.4696 10 16.9609 10.2107 16.5858 10.5858C16.2107 10.9609 16 11.4696 16 12C16 12.5304 16.2107 13.0391 16.5858 13.4142C16.9609 13.7893 17.4696 14 18 14H22" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <span>Digital coupons</span>
                </div>
                <div className="feature-block position-absolute hero-feature3">
                  <div style={{
                    backgroundColor: '#22c55e',
                    borderRadius: '50%',
                    width: '48px',
                    height: '48px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M9 12L11 14L15 10" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <span>8112 digital verification</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Manufacturers Section */}
      <section className="section manufacturers-section">
        <div className="container">
          <div className="section-title text-center mb-5">
            <h3>FOR MANUFACTURERS</h3>
            <h2>Manufacturers</h2>
            <p className="intro">
              Follow these simple steps to get your coupons live and start experiencing<br />
              increased sales and customer engagement.
            </p>
          </div>

          <div className="manufacturer-timeline" ref={timelineRef}>
            <div className="timeline-line" ref={timelineLineRef}></div>
            <div className="timeline-item timeline-left">
              <div className="timeline-content">
                <h4 className="step-title">Register with The Coupon Bureau</h4>
                <p>To issue secure GS1 digital coupons, your brand must first be registered with The Coupon Bureau. This ensures universal validation and redemption at all participating retailers.</p>
                <p className="text-muted">Not registered with The Coupon Bureau yet? <a href="#" onClick={(e) => { e.preventDefault(); navigate('/get-started'); }}>Click here</a> to get started or contact us and we'll walk you through it.</p>
              </div>
              <div className="timeline-number">1</div>
            </div>

            <div className="timeline-item timeline-right">
              <div className="timeline-number">2</div>
              <div className="timeline-content">
                <h4 className="step-title">Create Your Coupons</h4>
                <p>Log into the iClipCoupons dashboard to build your coupons. We handle formatting, compliance, and offer setup—so you can focus on the message.</p>
              </div>
            </div>

            <div className="timeline-item timeline-left">
              <div className="timeline-content">
                <h4 className="step-title">Distribute Anywhere</h4>
                <p>Get your coupons to shoppers—wherever they are:<br />
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', marginTop: '8px' }}>
                  Feature it in the ClipCoupons app
                  <span style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '20px',
                    height: '20px',
                    flexShrink: 0
                  }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="12" fill="#dbeafe"/>
                      <rect x="8" y="5" width="8" height="14" rx="1" stroke="#3b82f6" strokeWidth="1.5" fill="none"/>
                    </svg>
                  </span>
                </span><br />
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', marginTop: '4px' }}>
                  Share via email, social media, QR code, or your website.
                  <span style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '20px',
                    height: '20px',
                    flexShrink: 0
                  }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="12" fill="#dbeafe"/>
                      <rect x="6" y="7" width="12" height="10" rx="1" stroke="#3b82f6" strokeWidth="1.5" fill="none"/>
                      <path d="M6 8l6 4 6-4" stroke="#3b82f6" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </span>
                </span></p>
              </div>
              <div className="timeline-number">3</div>
            </div>

            <div className="timeline-item timeline-right">
              <div className="timeline-number">4</div>
              <div className="timeline-content">
                <h4 className="step-title">Customers Redeem In-Store</h4>
                <p>Shoppers scan the coupon right at the register. It's fast, secure, and fully traceable.</p>
              </div>
            </div>

            <div className="timeline-item timeline-left">
              <div className="timeline-content">
                <h4 className="step-title">Track Scans & Performance</h4>
                <p>See your coupon in performing. We track every scan across retailers in real-time and display it in your manufacturer dashboard—so you can monitor engagement and measure ROI with confidence.</p>
              </div>
              <div className="timeline-number">5</div>
            </div>
          </div>

          <div className="text-center mt-5">
            <p className="mb-4">Get started today and unlock the power of digital coupons to grow your brand.</p>
            <button className="theme-btn" onClick={() => navigate('/get-started')}>Create Your Coupon Now</button>
          </div>
        </div>
      </section>

      {/* Built for Brands Section */}
      <section className="section built-for-brands-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="brands-image">
                <Image src={ManufacturerImage} alt="Brands" className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="title-section">
                <h2>Built for <span>Brands and Manufacturers</span></h2>
                <p>Your Savings Simplified with Digital Coupons.</p>
              </div>
              <ul className="benefit-list mt-4">
                <li>Reach millions of shoppers—digitally</li>
                <li>Eliminate fraud with real-time validation</li>
                <li>Track performance with detailed reporting</li>
              </ul>
              <p className="mt-4"><strong>Trusted by Brands. Backed by The Coupon Bureau. Built for Results.</strong></p>
            </div>
          </div>
        </div>
      </section>

      {/* Book a Demo Section */}
      <section id="contact" className="section book-demo-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="demo-content">
                <h2>Book a Demo to Get Started</h2>
                <p>Finding the best deals and keeping you stay effortlessly, we make digital coupon easy and rewarding.</p>
                <ul className="contact-info-list">
                  <li>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="white" strokeWidth="2"/>
                      <path d="M22 6L12 13L2 6" stroke="white" strokeWidth="2"/>
                    </svg>
                    <span>support@iclipcoupons.com</span>
                  </li>
                  <li>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z" stroke="white" strokeWidth="2"/>
                      <circle cx="12" cy="10" r="3" stroke="white" strokeWidth="2"/>
                    </svg>
                    <span>342 Main Street, Suite #103 Boston, New York 2628</span>
                  </li>
                  <li>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M22 16.92V19.92C22 20.4728 21.5523 20.92 21 20.92H3C2.44772 20.92 2 20.4728 2 19.92V16.92" stroke="white" strokeWidth="2"/>
                      <path d="M15.5 9C16.88 9 18 7.88 18 6.5C18 5.12 16.88 4 15.5 4C14.12 4 13 5.12 13 6.5C13 7.88 14.12 9 15.5 9Z" stroke="white" strokeWidth="2"/>
                    </svg>
                    <span>(617) 229-2757</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6">
              <form className="demo-form">
                <div className="row">
                  <div className="col-12 mb-3">
                    <input type="text" className="form-control" placeholder="Full name" />
                  </div>
                  <div className="col-md-6 mb-3">
                    <input type="email" className="form-control" placeholder="Email" />
                  </div>
                  <div className="col-md-6 mb-3">
                    <input type="tel" className="form-control" placeholder="Phone" />
                  </div>
                  <div className="col-12 mb-3">
                    <textarea className="form-control" rows="5" placeholder="Message"></textarea>
                  </div>
                  <div className="col-12">
                    <button type="submit" className="theme-btn white-btn w-auto">Submit Now</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Services;
